import { render, staticRenderFns } from "./Emissoes.vue?vue&type=template&id=dcd4c2c4"
import script from "./Emissoes.vue?vue&type=script&lang=js"
export * from "./Emissoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports